import apiClient from "../apiClient";

const resource = "lookups";

export default {
    getLookups: () => apiClient.get(`${resource}`),
    getDoctors: () => apiClient.get(`${resource}/doctors`),
    getReasons: (id) => apiClient.get(`${resource}/reasons?doctorId=${id}`),
    getDepartments: () => apiClient.get(`${resource}/departments`),
    getMedicines: () => apiClient.get(`${resource}/medicines`),
    getPharmacyMedicines: () => apiClient.get(`${resource}/pharmacyMedicines`),
    getSuppliers: () => apiClient.get(`${resource}/suppliers`),
    getServices: () => apiClient.get(`${resource}/services`),
    getSubServices: () => apiClient.get(`${resource}/subServices`),
    getSpecialties: () => apiClient.get(`${resource}/specialties`),
    getAnalysis: (id) => apiClient.get(`${resource}/${id}/Analysis`),
    getStores: () => apiClient.get(`${resource}/store`),
       //erp service
    getPricesList: () => apiClient.get(`${resource}/getPricesList`),
    // getAllItemPriceList: (name) => apiClient.get(`${resource}/getAllItemPriceList?priceList=${name}`),
    getAllItem: (name) => apiClient.get(`${resource}/allItem?priceList=${name}`),
    getAllItemPriceList: (name) => apiClient.get(`${resource}/ItemsWithPricesAsync?priceList=${name}`),
    GetItemByProcedure: (name) => apiClient.get(`${resource}/ItemByProcedure?priceList=${name}`),
    getProcedures: () => apiClient.get(`${resource}/procedures`),
    getPaymentAccounts: () => apiClient.get(`${resource}/paymentAccounts`),
};
